import React, { Component } from "react";
import moment from "moment-timezone";
import Calendar from "react-awesome-calendar";
import Bridge from "../../utils/Bridge";
import "./calender-custom.css";

class CalenderData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: new Date(),
      calenderdata: [],
      events: [],
      loading: false,
      weekdays: [
        { name: "Sunday", back: 0, front: 6 },
        { name: "Monday", back: 1, front: 5 },
        { name: "Tuesday", back: 2, front: 4 },
        { name: "Wednesday", back: 3, front: 3 },
        { name: "Thursday", back: 4, front: 2 },
        { name: "Friday", back: 5, front: 1 },
        { name: "Saturday", back: 6, front: 0 },
      ],
      months: [
        { name: "Jan", num: 0 },
        { name: "Feb", num: 1 },
        { name: "Mar", num: 2 },
        { name: "Apr", num: 3 },
        { name: "May", num: 4 },
        { name: "Jun", num: 5 },
        { name: "Jul", num: 6 },
        { name: "Aug", num: 7 },
        { name: "Sep", num: 8 },
        { name: "Oct", num: 9 },
        { name: "Nov", num: 10 },
        { name: "Dec", num: 11 },
      ],
      current_month: 0,
      current_year: 0,
      days_in_month: 0,
      active1: false,
      active2: false,
      active3: false,
      active4: false,
      active5: false,
      session_list: [],
      proctored_session_list:[]
    };
    this.calendar = React.createRef();
    this.previousCalendarMode = null;
    this.monthBeforeYearView = null;
    this.yearBeforeYearView = null;
    this.isRestoringCalendarMonth = false;
  }
  componentDidMount() {
    let current_month = moment().format("MMM");
    for (let item of this.state.months) {
      if (item.name == current_month) {
        this.setState({
          current_month: item.num,
          current_year: moment().format("YYYY"),
        });
      }
    }
    let daysInMonth = moment().daysInMonth();
    this.setState(
      {
        days_in_month: daysInMonth,
        calenderdata: this.props.sessions,
      },
      () => this.showcheckboxactive()
    );
    const details = this.calendar.current?.getDetails();
    if (details) {
      this.monthBeforeYearView = details.month;
      this.yearBeforeYearView = details.year;
      this.previousCalendarMode = details.mode;
    }
    if (this.props.sessions.length > 0) {

      if(this.props.type=='LE Study'){
        this.setState(
          {
            calenderdata: this.props.sessions,
            session_list: this.props.sessions,
          },
          () => {
            this.setLEStudyEvents()
          }
        );
      }else{
        this.setState(
          {
            calenderdata: this.props.sessions,
            session_list: this.props.sessions,
            procotored_session_list:this.props.procotored_session_list
          },
          () => {
              this.setEvents()
          }
        );
      }
      
    }
  }
  setLEStudyEvents = () => {
    let data = this.state.session_list;
  
    let newEvents = [];
    if (data.length > 0) {
      let count = 1;
      let current_month = this.state.current_month;
      let all_dates = "";
      for (let item of data) {
        // ============= acti graph time completed ===========
        
        let session_start_date = moment.utc(item.date_created).format(
          "YYYY-MM-DD"
        );
        let session_end_date = moment.utc(item.date_created).format(
          "YYYY-MM-DD"
        );
        let current_year = moment(session_start_date).format("YYYY");
        // for selected dates
        let monthname = moment(session_start_date).format("MMM");
        let month = 0;
        for (let item of this.state.months) {
          if (item.name == monthname) {
            month = item.num;
          }
        }
        if (current_month == month && this.state.current_year == current_year) {
          all_dates = item.date_created + "," + item.date_created;
          // all_dates = item.all_actigraph_dates;
        }
        var dates = this.getDatesBetween(session_start_date, session_end_date);
        if (all_dates) {
          let all_combined_dates = all_dates.split(",");
          let new_arr = [];
          for (let item of all_combined_dates) {
            if (item) {
              new_arr.push(moment(item).format("YYYY-MM-DD"));
            }
          }
        }
        // =================== Showing selected date ==============================
        for (let singleDate of dates) {
          let day = moment(singleDate).format("DD");
          let highlight_obj = {
            id: count,
            color: "",
            from: `${singleDate}`,
            to: `${singleDate}`,
          };
          newEvents = [...newEvents, highlight_obj];
        }
        // this code for grey line
        let obj = {
          id: count,
          color: "#fff",
          from: session_start_date,
          to: session_end_date,
          title: ``,
        };
        // + "T00:00:00+00:00"

        newEvents.push(obj);
        count++;
      } 

      this.setState({ events: newEvents }, () => {
        setTimeout(() => {
          let date_list = [];
          if (all_dates) {
            let dates = all_dates.split(",");
            for (let item of dates) {
              date_list.push(moment(item).format("DD"));
            }
          }
          
          let eventtitle = document.querySelectorAll(".eventTitle");
          eventtitle.forEach((item, index) => {
            if (item) {
              let parentElement = item.parentElement.parentElement.parentElement;              
              parentElement.classList.add("le-study-selected");
              // console.log/('parentDiv',classList);
              // item.classList.add("le-study-selected-date");
            }
          });
        }, 500);
      });
    }
  };
  getDatesBetween = (fromDate, toDate) => {
    const dateArray = [];
    let currentDate = new Date(fromDate);

    while (currentDate <= new Date(toDate)) {
      dateArray.push(new Date(currentDate).toISOString().split("T")[0]); // Format as YYYY-MM-DD
      currentDate.setDate(currentDate.getDate() + 1); // Increment date
    }

    return dateArray;
  };
  setEvents = () => {
    let data = this.state.session_list;
  
    let newEvents = [];
    if (data.length > 0) {
      let count = 1;
      let current_month = this.state.current_month;
      let all_dates = "";
      for (let item of data) {
        // ============= acti graph time completed ===========
        // left arm
        let la_hour = Math.floor(Number(item.left_arm_total_duration) / 3600);
        let la_min = Math.floor((item.left_arm_total_duration % 3600) / 60);
        let la_sec = Math.floor(item.left_arm_total_duration % 60);
        let left_arm_time = la_hour + " hrs " + la_min + " min";
        // left arm
        let ll_hour = Math.floor(Number(item.left_leg_total_duration) / 3600);
        let ll_min = Math.floor((item.left_leg_total_duration % 3600) / 60);
        let ll_sec = Math.floor(item.left_leg_total_duration % 60);
        let left_leg_time = ll_hour + " hrs " + ll_min + " min";
        // right arm
        let ra_hour = Math.floor(Number(item.right_arm_total_duration) / 3600);
        let ra_min = Math.floor((item.right_arm_total_duration % 3600) / 60);
        let ra_sec = Math.floor(item.right_arm_total_duration % 60);
        let right_arm_time = ra_hour + " hrs " + ra_min + " min";
        // right leg
        let rl_hour = Math.floor(Number(item.right_leg_total_duration) / 3600);
        let rl_min = Math.floor((item.right_leg_total_duration % 3600) / 60);
        let rl_sec = Math.floor(item.right_leg_total_duration % 60);
        let right_leg_time = rl_hour + " hrs " + rl_min + " min";

        let session_start_date = moment(item.session_start_date).format(
          "YYYY-MM-DD"
        );
        let session_end_date = moment(item.session_end_date).format(
          "YYYY-MM-DD"
        );
        let current_year = moment(session_start_date).format("YYYY");
        // for selected dates
        let monthname = moment(session_start_date).format("MMM");
        let month = 0;
        for (let item of this.state.months) {
          if (item.name == monthname) {
            month = item.num;
          }
        }
        if (current_month == month && this.state.current_year == current_year) {
          all_dates = item.all_start_time_dates + "," + item.all_end_time_dates;
          // all_dates = item.all_actigraph_dates;
        }
        var dates = this.getDatesBetween(session_start_date, session_end_date);
        if (all_dates) {
          let all_combined_dates = all_dates.split(",");
          let new_arr = [];
          for (let item of all_combined_dates) {
            if (item) {
              new_arr.push(moment(item).format("YYYY-MM-DD"));
            }
          }
        }
        // =================== Showing selected date ==============================
        for (let singleDate of dates) {
          let day = moment(singleDate).format("DD");
          let highlight_obj = {
            id: count,
            color: "",
            from: `${singleDate}`,
            to: `${singleDate}`,
            title: `${day}`,
            // title: `From Date: ${singleDate}- To Date: ${singleDate}`,
            asymptomatic_generated_session_id:
              item.asymptomatic_generated_session_id,
          };
          newEvents = [...newEvents, highlight_obj];
        }
        // this code for grey line
        let obj = {
          id: count,
          color: "#afabab",
          from: session_start_date,
          to: session_end_date,
          title: ``,
          asymptomatic_generated_session_id:
            item.asymptomatic_generated_session_id,
        };
        // + "T00:00:00+00:00"

        newEvents.push(obj);
        count++;
      }

      let procotored_session_list=this.props.procotored_session_list
      let new_arr=[];
      let unique_arr=[];
      for(let item of procotored_session_list){
        if(item.entry_date){
          let current_year = moment(item.entry_date).format("YYYY");
          // for selected dates
          let monthname = moment(item.entry_date).format("MMM");
          let month = 0;
          for (let item of this.state.months) {
            if (item.name == monthname) {
              month = item.num;
            }
          }
          let entry_date = moment(item.entry_date).format("YYYY-MM-DD");
          if(!unique_arr.includes(entry_date)){
            if(month==current_month && this.state.current_year==current_year){
              let day = moment(item.entry_date).format("DD");
              new_arr.push(day);
              unique_arr.push(entry_date)
            }
          }
        }
      }
      this.setState({ events: newEvents }, () => {
        setTimeout(() => {
          let date_list = [];
          if (all_dates) {
            let dates = all_dates.split(",");
            for (let item of dates) {
              date_list.push(moment(item).format("DD"));
            }
          }
          let eventtitle = document.querySelectorAll(".eventTitle");
          eventtitle.forEach((item, index) => {
            if (item.innerHTML != "") {
              if(new_arr.includes(item.innerHTML)){
                // proctored session done
                item.classList.add("done-proctored-session");
              }else{
                // range select generated sesssions
                item.classList.add("selected-date");
              }
              if (date_list.includes(item.innerHTML)) {
                item.classList.add("in_progress_date");
              }
            }
          });
        }, 500);
      });
    }
  };
  // show icons active
  showcheckboxactive = () => {
    let daysInMonth = this.state.days_in_month;
    let data = this.props.sessions;
    let current_month = this.state.current_month;

    let active1 = false;
    let active2 = false;
    let active3 = false;
    let active4 = false;
    let active5 = false;
    let active6 = false;

    for (let item of data) {
      let selecteddate = moment(item.entry_date).format("YYYY-MM-DD");
      let monthname = moment(selecteddate).format("MMM");
      let current_year = moment(selecteddate).format("YYYY");

      let month = 0;
      for (let item of this.state.months) {
        if (item.name == monthname) {
          month = item.num;
        }
      }

      if (current_month == month && this.state.current_year == current_year) {
        const d = new Date(selecteddate);
        const date = d.getDate();
        const day = d.getDay();
        const weekOfMonth = Math.ceil((date - 1 - day) / 7);

        if (weekOfMonth == "0") {
          active1 = true;
        } else if (weekOfMonth == "1") {
          active2 = true;
        } else if (weekOfMonth == "2") {
          active3 = true;
        } else if (weekOfMonth == "3") {
          active4 = true;
        } else if (weekOfMonth == "4") {
          active5 = true;
        }
      }
    }
    setTimeout(() => {
      this.setState({
        active1,
        active2,
        active3,
        active4,
        active5,
      });
    }, 1000);
  };
  test = (mJsDate) => {
    var str =
      mJsDate.toLocaleString().substring(0, 3) +
      " number " +
      Math.ceil(mJsDate.date() / 7) +
      " of the month";
    return str;
  };
  restoreCalendarMonth = (targetYear, targetMonth) => {
    const calendar = this.calendar.current;
    if (!calendar) return;

    this.isRestoringCalendarMonth = true;
    calendar.setState(
      { year: targetYear, month: targetMonth, day: 1, mode: "monthlyMode" },
      () => {
        this.isRestoringCalendarMonth = false;
        this.previousCalendarMode = "monthlyMode";
        this.monthBeforeYearView = targetMonth;
        this.yearBeforeYearView = targetYear;

        const params = calendar.getDetails();
        let current_month = params.month;
        let current_year = params.year;
        this.setState(
          { current_month: current_month, current_year: current_year },
          () => {
            if (this.props.type == "LE Study") {
              this.setLEStudyEvents();
            } else {
              this.setEvents();
            }
          }
        );
        let dateval = params.year + "-" + (params.month + 1) + "-" + params.day;
        let daysInMonth = moment(dateval).daysInMonth();
        this.setState({ days_in_month: daysInMonth }, () =>
          this.showcheckboxactive()
        );
      }
    );
  };
  onChange = (params) => {
    if (this.isRestoringCalendarMonth) {
      return;
    }

    const prevMode = this.previousCalendarMode;

    if (params.mode === "monthlyMode" && prevMode === "yearlyMode") {
      const targetMonth =
        this.monthBeforeYearView !== null
          ? this.monthBeforeYearView
          : moment().month();
      const targetYear =
        this.yearBeforeYearView !== null
          ? this.yearBeforeYearView
          : moment().year();

      if (params.month !== targetMonth || params.year !== targetYear) {
        this.restoreCalendarMonth(targetYear, targetMonth);
        return;
      }
    }

    if (params.mode === "dailyMode" || params.mode === "monthlyMode") {
      this.monthBeforeYearView = params.month;
      this.yearBeforeYearView = params.year;
    } else if (params.mode === "yearlyMode" && prevMode !== "yearlyMode") {
      if (this.monthBeforeYearView === null || this.yearBeforeYearView === null) {
        this.monthBeforeYearView = this.state.current_month;
        this.yearBeforeYearView =
          Number(this.state.current_year) || moment().year();
      }
    }

    this.previousCalendarMode = params.mode;

    if (params.mode == "monthlyMode") {
      if (this.props.type == "LE Study") {
        this.setLEStudyEvents();
        return;
      } else {
        this.setEvents();
        return;
      }
    } else {
      let selected_date = params.year + "-" + params.month + "-" + params.day;
      selected_date = moment(selected_date)
        .add(1, "month")
        .format("YYYY-MM-DD");
      let query_params =
        "?eals_id=" +
        localStorage.getItem("ap_eals_id") +
        "&date=" +
        selected_date;
      Bridge.personal_data_viewer
        .get_actigraph_session_log_list(query_params)
        .then((res) => {
          if (res.status == 1) {
            let arr = this.state.events;
            let other_arr = [];
            for (let item of arr) {
              if (moment(item.from).format("YYYY-MM-DD") == selected_date) {
              } else {
                other_arr.push(item);
              }
            }
            arr = other_arr;
            let index = 200;
            let new_arr = [];
            let timezone = moment.tz.guess();
            for (let item of res.data) {
              let start_datetime = moment
                .tz(item.start_datetime, timezone)
                .format("YYYY-MM-DDTHH:mm:ss");
              let end_datetime = moment
                .tz(item.end_datetime, timezone)
                .format("YYYY-MM-DDTHH:mm:ss");
              let hour = Math.floor(Number(item.duration) / 3600);
              let min = Math.floor((item.duration % 3600) / 60);
              let time_in_string = hour + " hrs " + min + " min";
              let limb_type = "";
              if (item.limb_type == "left_leg") {
                limb_type = "LL";
              } else if (item.limb_type == "left_arm") {
                limb_type = "LA";
              } else if (item.limb_type == "right_arm") {
                limb_type = "RA";
              } else if (item.limb_type == "right_leg") {
                limb_type = "RL";
              }
              // .tz(item.end_datetime, timezone)
              let obj = {
                id: index,
                color: "#f29d1d",
                from: start_datetime + "+00:00",
                to: end_datetime + "+00:00",
                title: "Total Wear Time: " + time_in_string,
              };
              arr.push(obj);
              new_arr.push(obj);
              index++;
            }
            this.setState({ events: arr });
          }
        })
        .catch((err) => {});
    }

    let current_month = params.month;
    let current_year = params.year;
    this.setState(
      { current_month: current_month, current_year: current_year },
      () => {
        if (this.props.type == "LE Study") {
          this.setLEStudyEvents();
          return;
        } else {
          this.setEvents();
        }
      }
    );
    /// setting days in month
    let dateval = params.year + "-" + (params.month + 1) + "-" + params.day;
    let daysInMonth = moment(dateval).daysInMonth();
    this.setState({ days_in_month: daysInMonth }, () =>
      this.showcheckboxactive()
    );
  };
  onClickEvent = (event) => {
  };
  render() {
    return (
      <>
        <div className="calender-outer" style={{ height: "100%" }}>
          <div className="row" style={{ marginBottom: 25, paddingTop: 20 }}>
            <div
              className="col-xl-12 col-lg-12 d-flex calender-warpper"
              style={{ paddingLeft: 22 }}
            >
              <br />
              <div
                className="full-calender-wrapper-block"
                style={{ width: "90%" }}
              >
                <Calendar
                  events={this.state.events}
                  ref={this.calendar}
                  onChange={this.onChange}
                  showDay={false}
                  mode={"daily"}
                />
              </div>
              <div className="active_sessions_of_weeks">
                <li>
                  <div
                    className={
                      this.state.active1 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active2 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active3 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active4 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                  <div className="line"></div>
                </li>
                <li>
                  <div
                    className={
                      this.state.active5 == true ? "circle active" : "circle"
                    }
                  >
                    <box-icon
                      name="check"
                      color="#fff"
                      style={{
                        position: "relative",
                        top: 2,
                        left: 3,
                      }}
                    ></box-icon>
                  </div>
                </li>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CalenderData;
